import React, { useState, useEffect, useCallback } from 'react';
import { activityAPI, userAPI } from '../services/api';
import { toast } from 'react-toastify';
import '../styles/UserManagement.css';

const ACTION_LABELS = {
  login: 'Đăng nhập',
  change_password: 'Đổi mật khẩu',
  send_zns: 'Gửi ZNS đơn lẻ',
  send_bulk: 'Gửi hàng loạt',
  create_template: 'Tạo template',
  update_template: 'Sửa template',
  delete_template: 'Xoá template',
  sync_templates: 'Đồng bộ template',
  create_rule: 'Tạo automation',
  update_rule: 'Sửa automation',
  delete_rule: 'Xoá automation',
  toggle_rule: 'Bật/tắt automation',
  create_user: 'Tạo user',
  update_user: 'Sửa user',
  update_perms: 'Đổi quyền',
  toggle_user: 'Khoá/mở user',
  reset_password: 'Reset mật khẩu',
  delete_user: 'Xoá user'
};

function ActivityLogs() {
  const [logs, setLogs] = useState([]);
  const [users, setUsers] = useState([]);
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({ user_id: '', module: '' });

  useEffect(() => {
    userAPI.getAll().then((r) => r.data.success && setUsers(r.data.data)).catch(() => {});
    userAPI.getModules().then((r) => r.data.success && setModules(r.data.data)).catch(() => {});
  }, []);

  const loadLogs = useCallback(async () => {
    setLoading(true);
    try {
      const params = { page, limit: 30 };
      if (filters.user_id) params.user_id = filters.user_id;
      if (filters.module) params.module = filters.module;
      const res = await activityAPI.getLogs(params);
      if (res.data.success) {
        setLogs(res.data.data.logs);
        setTotalPages(res.data.data.pagination.total_pages || 1);
      }
    } catch (e) {
      toast.error('Không tải được nhật ký');
    } finally {
      setLoading(false);
    }
  }, [page, filters]);

  useEffect(() => { loadLogs(); }, [loadLogs]);

  const fmtMeta = (raw) => {
    if (!raw) return null;
    try {
      const m = typeof raw === 'string' ? JSON.parse(raw) : raw;
      return Object.entries(m).map(([k, v]) => `${k}: ${v}`).join(' · ');
    } catch { return null; }
  };

  return (
    <div className="um-container">
      <div className="page-header">
        <h1>Nhật ký hoạt động</h1>
        <p>Lịch sử thao tác của từng người dùng trên hệ thống</p>
      </div>

      <div className="card">
        <div className="um-filters">
          <select
            value={filters.user_id}
            onChange={(e) => { setPage(1); setFilters({ ...filters, user_id: e.target.value }); }}
          >
            <option value="">— Tất cả người dùng —</option>
            {users.map((u) => (
              <option key={u.id} value={u.id}>{u.full_name || u.username}</option>
            ))}
          </select>

          <select
            value={filters.module}
            onChange={(e) => { setPage(1); setFilters({ ...filters, module: e.target.value }); }}
          >
            <option value="">— Tất cả module —</option>
            {modules.map((m) => (
              <option key={m.key} value={m.key}>{m.label}</option>
            ))}
          </select>

          <button className="btn-secondary" onClick={loadLogs}>Làm mới</button>
        </div>

        {loading ? (
          <div className="loading">Đang tải...</div>
        ) : (
          <table className="um-table">
            <thead>
              <tr>
                <th>Thời gian</th>
                <th>Người dùng</th>
                <th>Hành động</th>
                <th>Chi tiết</th>
                <th>IP</th>
              </tr>
            </thead>
            <tbody>
              {logs.length === 0 ? (
                <tr><td colSpan="5" className="empty-state">Chưa có dữ liệu</td></tr>
              ) : logs.map((log) => (
                <tr key={log.id}>
                  <td className="um-sub">{new Date(log.created_at).toLocaleString('vi-VN')}</td>
                  <td>{log.full_name || log.username || '—'}</td>
                  <td>
                    <span className={`um-chip ${log.status_code >= 400 ? 'chip-fail' : ''}`}>
                      {ACTION_LABELS[log.action] || log.action}
                    </span>
                  </td>
                  <td>
                    <div>{log.description}</div>
                    {fmtMeta(log.metadata) && <div className="um-sub">{fmtMeta(log.metadata)}</div>}
                  </td>
                  <td className="um-sub">{log.ip_address || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {totalPages > 1 && (
          <div className="um-pagination">
            <button className="btn-secondary" disabled={page <= 1} onClick={() => setPage(page - 1)}>← Trước</button>
            <span>Trang {page}/{totalPages}</span>
            <button className="btn-secondary" disabled={page >= totalPages} onClick={() => setPage(page + 1)}>Sau →</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ActivityLogs;
